import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import '../styles/LegalPages.css';

const RefundPolicy = () => {
  // Scroll to top on mount - immediate
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="legal-page">
      <SEO canonical="/refund-policy" />
      <header className="legal-header">
        <div className="container">
          <Link to="/" className="legal-back-link">
            <ArrowLeft size={18} />
            <span>Back to Home</span>
          </Link>
          <Link to="/" className="legal-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_accordion-repair/artifacts/06uiebgi_Variant%201_Full%20Logo_Vector%20copy%202.png" 
              alt="All Secured" 
            />
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <div className="container">
          <article className="legal-article">
            <h1>Refund Policy</h1>
            <p className="legal-subtitle">All Secured Refund Policy</p>
            <p className="legal-effective-date">Effective Date: 12 February 2026</p>

            <section>
              <h2>1. General Policy</h2>
              <p>All Secured provides digital educational content delivered immediately upon purchase. Due to the nature of digital access, purchases are generally non-refundable once access has been granted.</p>
            </section>

            <section>
              <h2>2. Refund Eligibility</h2>
              <p>We may issue a refund in limited circumstances, including:</p>
              <ul>
                <li>Duplicate payments</li>
                <li>Technical failure preventing access that cannot be resolved</li>
                <li>Accidental purchase reported promptly</li>
                <li>Where required under Australian Consumer Law</li>
              </ul>
              <p>Refund requests must be submitted within 7 days of purchase.</p>
            </section>

            <section>
              <h2>3. Non-Refundable Circumstances</h2>
              <p>Refunds will not be provided where:</p>
              <ul>
                <li>Course content has been substantially accessed or completed</li>
                <li>The purchaser changes their mind</li>
                <li>The purchaser lacks the required device or internet access</li>
                <li>The course does not meet subjective expectations</li>
              </ul>
            </section>

            <section>
              <h2>4. Australian Consumer Law</h2>
              <p>Nothing in this policy excludes or limits rights under the Australian Consumer Law. Where a product fails to meet consumer guarantees, you may be entitled to a repair, replacement, or refund.</p>
            </section>

            <section>
              <h2>5. Access Revocation</h2>
              <p>If a refund is issued, course access will be revoked.</p>
            </section>

            <section>
              <h2>6. Contact</h2>
              <p>Refund requests must be submitted to:</p>
              <p><a href="mailto:allsecured.com.au@proton.me">allsecured.com.au@proton.me</a></p>
            </section>
          </article>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <p>&copy; 2025 All Secured. All rights reserved.</p>
          <p className="legal-footer-stripe">Secure payments powered by Stripe.</p>
        </div>
      </footer>
    </div>
  );
};

export default RefundPolicy;
